import classNames from 'clsx';
import React from 'react';

import type { SgmOpportunity } from '@swf/generated/types/api/sports';
import { ExpandablePanel, Icon } from '@swf/sports/components';

import styles from '../../MultipleAccordion.scss';
import EventTitle from '../EventTitle/EventTitle';
import SgmBetDetails from '../SgmBetDetails/SgmBetDetails';

interface Props {
  receiptItem: SgmOpportunity;
}

const SgmReceiptItem: React.FC<Props> = ({ receiptItem }) => (
  <>
    {receiptItem.sgmData.map((item, index) => (
      <ExpandablePanel
        openInitially={true}
        title={<EventTitle {...item} />}
        className={styles.panel}
        key={index}
      >
        <div className={styles.runners}>
          {item.descriptions.map((description, i) => (
            <div key={i} className={classNames(styles.runner, styles.sgmRunner)}>
              <Icon name="bet-builder" size="xl" />

              <SgmBetDetails sgmDescription={description} />
            </div>
          ))}
        </div>
      </ExpandablePanel>
    ))}
  </>
);

export default SgmReceiptItem;
